import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useDataStudioAssetSearch } from "../../hooks/useDataStudioAssetSearch";
import { DataStudioSecondaryPanel } from "./DataStudioSecondaryPanel";

/**
 * Owns the search term and sort order so both reach the asset search API.
 *
 * Searching server-side matters here: the API matches on the asset `name`
 * across the whole tenant, where the previous client-side filter could only
 * see the page already loaded.
 */
export const DataStudioSecondaryPanelConnected: React.FC = () => {
  const { connectionId } = useParams<{ connectionId?: string }>();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

  const assetsQuery = useDataStudioAssetSearch({
    search: searchTerm,
    sortOrder,
    connectionIds: connectionId ? [connectionId] : undefined,
  });

  return (
    <DataStudioSecondaryPanel
      tables={assetsQuery.data?.items ?? []}
      total={assetsQuery.data?.total ?? 0}
      isLoading={assetsQuery.isLoading}
      errorMessage={assetsQuery.errorMessage}
      searchTerm={searchTerm}
      onSearchTermChange={setSearchTerm}
      onSortOrderChange={setSortOrder}
    />
  );
};

export default DataStudioSecondaryPanelConnected;
